import {httpCore} from "./instance/http";

export const postStatistic     = params => httpCore.post('callme/rest/follow-link',params);
